import Progress from 'redux-progress';

import type { MACGenericPropertyAction, MACGenericPropertyState } from '../models';
import { FETCH_GENERIC_PROPERTY } from '../actions/genericProperty';

export const initialState = {
  genericProperty: Progress.none,
};

export default (
  state: MACGenericPropertyState = initialState,
  action: MACGenericPropertyAction,
): MACGenericPropertyState => {
  if (action.type === FETCH_GENERIC_PROPERTY)
    return {
      ...state,
      genericProperty: {
        ...state.genericProperty,
        [action.fullKey]: action.progress,
      },
    };
  return state;
};
